(function () {
  document.querySelectorAll('[data-shoppable-setup]').forEach(function (stage) {
    var dots = stage.querySelectorAll('[data-shoppable-dot]');

    function closeAll() {
      stage.querySelectorAll('.shoppable-setup__card.is-open').forEach(function (card) {
        card.classList.remove('is-open');
      });
      stage.querySelectorAll('.shoppable-setup__dot.is-active').forEach(function (dot) {
        dot.classList.remove('is-active');
        dot.setAttribute('aria-expanded', 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.stopPropagation();
        var id = dot.getAttribute('data-shoppable-dot');
        var card = stage.querySelector('[data-shoppable-card="' + id + '"]');
        var willOpen = !card.classList.contains('is-open');
        closeAll();
        if (willOpen) {
          card.classList.add('is-open');
          dot.classList.add('is-active');
          dot.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!stage.contains(event.target)) {
        closeAll();
      }
    });
  });
})();
